import React, { Component } from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import { FormattedMessage } from 'react-intl'

export default class GridItem extends Component {
  state = {
    isHover: false,
  }

  addHover = () => {
    this.setState({ isHover: true })
  }

  removeHover = () => {
    this.setState({ isHover: false })
  }

  render() {
    const { imageMap, link, className } = this.props
    const { isHover } = this.state
    let title = link

    if (link === 'progetto') {
      title = 'Il Progetto'
    }

    if (link === 'relazioni-e-conferenze') {
      title = 'Relazioni e conferenze'
    }

    let locale = 'it'

    if (typeof window !== 'undefined') {
      locale = window.localStorage.getItem('locale')
    }

    const linkPrefix = locale === 'it' ? '' : '/en'

    return (
      <Link
        to={`${linkPrefix}/${link}`}
        className={`LinksGrid__Item ${className || ''}`}
        onMouseEnter={this.addHover}
        onMouseLeave={this.removeHover}
        onClick={this.removeHover}
      >
        {/* Immagine normale */}
        <Img
          critical
          sizes={imageMap[link].node.sizes}
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            zIndex: isHover ? -1 : 0,
          }}
        />
        {/* Immagine rollover */}
        <Img
          fadeIn={false}
          sizes={imageMap[`${link}Hover`].node.sizes}
          onLoad={this.stopPreloading}
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            zIndex: isHover ? 0 : -1,
          }}
        />
        <div className="LinksGrid__Item__Title">
          <FormattedMessage id={`gridItem.${link}`} />
        </div>
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/grid-item/index.js